export const generateTransactionId = (useCurrentTime: boolean, formId?: string): string => {
  const transctionElement = document.getElementById('TransactionId') as HTMLInputElement | null;
  const Id = transctionElement ? transctionElement.value : '';
  const timestamp = useCurrentTime
    ? new Date().getTime() * 10000
    : window.localStorage.getItem('timestamp');
  window.localStorage.setItem('timestamp', timestamp as string);
  const transactionId = Id
    ? Id.replace(/Timestamp/, timestamp?.toString())
        .replace(/PageId/, formId)
    : '';
  return transactionId;
};
